// src/presentation/pages/ClinicalExamination/sections/VisuospatialSection.tsx
import React from "react";
import { CardTitle } from "@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";
import { booleanRadioValue } from "../types";

interface VisuospatialSectionProps {
  getsLostFamiliarPlaces: boolean | null;
  difficultyRecognizingFaces: boolean | null;
  onGetsLostFamiliarPlacesChange: (value: boolean) => void;
  onDifficultyRecognizingFacesChange: (value: boolean) => void;
}

export const VisuospatialSection: React.FC<VisuospatialSectionProps> = ({
  getsLostFamiliarPlaces,
  difficultyRecognizingFaces,
  onGetsLostFamiliarPlacesChange,
  onDifficultyRecognizingFacesChange,
}) => {
  const { t } = useTranslation("patients");
  return (
    <div className=" border-gray-200">
      <div className="pb-3">
        <CardTitle className="text-base font-semibold text-gray-900">
          {t("clinicalSections.visuospatial.title")}
        </CardTitle>
      </div>
      <div className="space-y-6">
        {/* Getting Lost in Familiar Places */}
        <div>
          <p className="text-sm text-gray-700 mb-3">
            {t("clinicalSections.visuospatial.lostQuestion")}
          </p>
          <RadioGroup
            value={booleanRadioValue(getsLostFamiliarPlaces)}
            onValueChange={(val) =>
              onGetsLostFamiliarPlacesChange(val === "true")
            }
            className="flex gap-6"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="true" id="lost-yes" />
              <Label
                htmlFor="lost-yes"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.yes")}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="false" id="lost-no" />
              <Label
                htmlFor="lost-no"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.no")}
              </Label>
            </div>
          </RadioGroup>
        </div>

        {/* Difficulty Recognizing Faces/Objects */}
        <div>
          <p className="text-sm text-gray-700 mb-3">
            {t("clinicalSections.visuospatial.recognizingFacesQuestion")}
          </p>
          <RadioGroup
            value={booleanRadioValue(difficultyRecognizingFaces)}
            onValueChange={(val) =>
              onDifficultyRecognizingFacesChange(val === "true")
            }
            className="flex gap-6"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="true" id="faces-yes" />
              <Label
                htmlFor="faces-yes"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.yes")}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="false" id="faces-no" />
              <Label
                htmlFor="faces-no"
                className="text-[#1B1D21] cursor-pointer text-sm font-normal"
              >
                {t("clinicalSections.no")}
              </Label>
            </div>
          </RadioGroup>
        </div>
      </div>
    </div>
  );
};
